module.exports = __webpack_public_path__ + "static/media/icon.c7e61a2e.png";